import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import './JumpToSection.scss';

export const JumpToSection = ({ sections = [''], borderTop, uppercase }) => {
  const jumpToSectionClasses = classNames('jumpto-section', {
    'border-top': borderTop,
  });

  return (
    <div className={jumpToSectionClasses}>
      <div className='jumpto-title'>JUMP TO</div>
      {sections &&
        sections.map((section) => {
          const jumpToClasses = classNames(
            'jumpto-selection',
            uppercase && 'uppercase',
          );
          return (
            <div
              id={`selection-${section}`}
              className={jumpToClasses}
              key={section}
            >
              <a href={`#${section}`}>{section}</a>
            </div>
          );
        })}
    </div>
  );
};

JumpToSection.defaultProps = {
  borderTop: true,
  uppercase: false,
};

JumpToSection.propTypes = {
  sections: PropTypes.arrayOf(PropTypes.string).isRequired,
  borderTop: PropTypes.bool,
  uppercase: PropTypes.bool,
};

export default JumpToSection;
